import Router from './router';
import ScrollToTop from 'src/components/ScrollToTop';

import { AppProvider } from './provider';
import { RightPanelProvider } from 'src/components/layouts/RightPanelContext';
import RightPanel from 'src/components/layouts/RightPanel';
import { UploadBatchProvider } from 'src/features/uploads/UploadBatchContext';
import JobsWidget from 'src/features/uploads/components/JobsWidget';
import { AppPostHogErrorBoundary } from 'src/lib/posthog';
import AppErrorFallback from 'src/components/AppErrorFallback';

const App = () => {
  return (
    <AppPostHogErrorBoundary fallback={<AppErrorFallback />}>
      <AppProvider>
        <RightPanelProvider>
          <UploadBatchProvider>
            <div className="">
              <ScrollToTop />
              <Router />
            </div>
            <RightPanel />
            <JobsWidget />
          </UploadBatchProvider>
        </RightPanelProvider>
      </AppProvider>
    </AppPostHogErrorBoundary>
  );
};

export default App;
